module.exports = __webpack_public_path__ + "assets/8ed304738d41d17042543d8d943a225a.png";